import React, { useState, useEffect, useRef } from 'react';

import LoadingSpinnerComponent from '../LoadingSpinnerComponent';
import TopKeywordsComponent from '../Dashboard/TopKeywordsComponent';
import ReviewsDistributionByIssue from './ReviewsDistributionByIssue';
import GroupPopUpComponent from './GroupPopUpComponent';
import EmptyMessageComponent from '../EmptyMessageComponent';
import ClientPlanManagementComponent from '../Client Management/ClientPlanManagementComponent';


import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faStore } from '@fortawesome/free-solid-svg-icons'
import { faGooglePlay, faAppStore } from '@fortawesome/free-brands-svg-icons'
import { GridOn, LocalOffer } from '@mui/icons-material';

import Alert from '@mui/joy/Alert';
import Typography from '@mui/joy/Typography';
import Select from '@mui/joy/Select';
import Option from '@mui/joy/Option';
import Button from '@mui/joy/Button';
import Modal from '@mui/joy/Modal';
import ModalDialog from '@mui/joy/ModalDialog';
import DialogTitle from '@mui/joy/DialogTitle';
import DialogContent from '@mui/joy/DialogContent';
import ModalClose from '@mui/joy/ModalClose';
import Card from '@mui/joy/Card';
import { Avatar, Box, Chip, Divider, FormLabel, Stack, Table, ModalOverflow } from '@mui/joy';
import { Add, Star } from '@mui/icons-material';

import WingmanKeywords from '../Wingman/WingmanKeywords';
import Rating from "@mui/material/Rating"
import DateFilter, { DateFilterValue } from '../Filters/DateFilter';
import { getDateRange } from '../../Helpers/DateHelpers';
import { cardStyles } from '../../styles/cardStyles';
import ReviewComponent from '../Reviews/ReviewComponent';
import { useAuth } from '../../context/authContext';

const networking = require('../../Networking/API');
const helper = require('../../Helpers/helpers');
const hbHelper = require('../../Helpers/heartbeatDataHandler');

// State constants and styling
const STATE_OPTIONS = [
    { value: 'all', label: 'All' },
    { value: 'new', label: 'New' },
    { value: 'follow', label: 'Follow' },
    { value: 'assigned', label: 'Assigned' },
    { value: 'closed', label: 'Closed' }
];

const STATE_COLORS: Record<string, any> = {
    'new': 'primary',
    'follow': 'warning',
    'assigned': 'info',
    'closed': 'success',
    'all': 'neutral'
};

const getStateColor = (state: string): any => {
    return STATE_COLORS[state?.toLowerCase()] || 'neutral';
};

function KeywordsComponent({ subscription, app }: any) {
    const { token } = useAuth();

    const [loading, setLoading] = useState(true);
    const [reviews, setReviews] = useState(null) as any[];
    const [issues, setIssues] = useState(null) as any[];
    const [groupToAdd, setGroupToAdd] = useState(false);
    const [viewMode, setViewMode] = useState('global');
    const [expanded, setExpanded] = useState(false);
    const [showReviews, setShowReviews] = useState(false);
    const [currentReviews, setCurrentReviews] = useState(null) as any[];
    const [currentWord, setCurrentWord] = useState('');
    const [showPlanSettings, setShowPlanSettings] = useState(false);

    //Filter states
    const [currentLimit, setCurrentLimit] = useState(5);
    const [currentStore, setCurrentStore] = useState('');
    const [currentSentiment, setCurrentSentiment] = useState('All');
    const [currentRating, setCurrentRating] = useState<number>(5);
    const [currentState, setCurrentState] = useState('');
    const [currentVersion, setCurrentVersion] = useState('All');
    const [currentTerritoryCode, setCurrentTerritoryCode] = useState('All');
    const [selectedFilter, setSelectedFilter] = useState<DateFilterValue>("last7");

    const hasFetched = useRef(false);
    const { start, end } = getDateRange(selectedFilter);

    useEffect(() => {
        if (!hasFetched.current) {
            getAllData();
            hasFetched.current = true;
        }

        setExpanded(false);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currentStore, currentSentiment, currentRating, currentVersion, currentTerritoryCode, selectedFilter]);

    const getAllData = () => {
        getData();
        getMainIssues();
    }

    function updatePage() {
        setGroupToAdd(false);
        setLoading(true);
        getAllData()
    }

    function getData() {
        networking.reviewsFor(app.id, token).then((reviews: any) => {
            setReviews(reviews);
        }).catch((error: Error) => {
            setLoading(false);
        });
    }

    function getMainIssues() {
        networking.issuesFor(app.id, token).then((issues: any) => {
            setIssues(issues);
            setLoading(false);
        }).catch((error: Error) => {
            setLoading(false);
        });
    }

    function filterByVersion(e: any) {
        e.preventDefault();

        const value = e.target.innerText;

        setCurrentVersion(value)
        setCurrentLimit(5);
    }

    function filterByStore(e: any) {
        e.preventDefault();

        const value = e.target.innerText.trim();

        setCurrentStore(value)
        setCurrentLimit(5);
    }

    function filterByState(e: any) {
        e.preventDefault();

        const value = e.target.innerText.trim().toLowerCase();
        const stateValue = STATE_OPTIONS.find(opt => opt.label.toLowerCase() === value)?.value || value;

        setCurrentState(stateValue)
        setCurrentLimit(5);
    }

    function filterBySentiment(e: any) {
        e.preventDefault();

        const value = e.target.innerText.trim();

        setCurrentSentiment(value)
        setCurrentLimit(5);
    }

    function filterByTerritoryCode(e: any, newValue: any) {
        e?.preventDefault();

        const value = newValue || e?.target?.innerText;

        setCurrentTerritoryCode(value)
    }

    function toggleView() {
        setViewMode(viewMode === 'global' ? 'detail' : 'global')
    }

    const replySent = (event: any) => {
        updatePage();
    };

    function showReviewsFor(word: string) {
        setCurrentWord(word);

        const r = currentItems.filter((review: Review) =>
            review.content.toLocaleLowerCase().includes(word.toLocaleLowerCase())
        )

        setCurrentReviews(r)
        setShowReviews(true)
    }

    var currentItems = reviews;
    var territories: any[] = [];
    var versions: any[] = [];

    if (issues && reviews) {
        reviews.sort(function (a: any, b: any) {
            return new Date(b.updated).getTime() - new Date(a.updated).getTime();
        });

        versions = [...new Set(reviews.map((r: any) => r.version))];
        versions.sort(function (a: any, b: any) {
            return a !== null && a.localeCompare(b, undefined, { numeric: true });
        });
        versions.unshift("All");

        // Extract territories for dropdown
        territories = [...new Set(currentItems.map((r: any) => r.territorycode).filter(Boolean))];
        territories.sort();
        territories.unshift("All");

        if (currentStore === 'Appstore') {
            currentItems = currentItems.filter((r: any) => r.store === 'applestore');

        } else if (currentStore === 'Playstore') {
            currentItems = currentItems.filter((r: any) => r.store === 'playstore');

        }

        if (currentVersion !== 'All') {
            currentItems = currentItems.filter((r: any) => r.version === currentVersion);
        }

        if (currentSentiment !== 'All') {
            currentItems = currentItems.filter((r: Review) => r.sentiment.toLowerCase() === currentSentiment.toLowerCase());
        }

        if (currentState && currentState !== 'all' && currentState !== '') {
            currentItems = currentItems.filter((r: any) => r.state?.toLowerCase() === currentState.toLowerCase());
        }

        if (currentTerritoryCode !== 'All') {
            currentItems = currentItems.filter((r: any) => r.territorycode === currentTerritoryCode);
        }

        //Apply Date filters
        currentItems = currentItems.filter((review: Review) => {
            const reviewDate = new Date(review.updated);
            return (!start || reviewDate >= start) && (!end || reviewDate <= end);
        });
    }

    const updateSubscription = (subscription: any) => {
    }

    return (
        <div className='keywords'>
             {/* Plan Modal */}
            <Modal
                open={showPlanSettings}
                onClose={() => setShowPlanSettings(false)}>
                <ModalOverflow>
                    <ModalDialog
                        color="neutral"
                        size="sm"
                        variant="plain">
                        <ModalClose />
                        <DialogTitle>
                            Plans & Billing
                        </DialogTitle>
                        <DialogContent>
                            Upgrade your plan to reply to reviews.
                        </DialogContent>
                        <div className='pt-4'>
                            <ClientPlanManagementComponent
                                subscription={subscription}
                                onSubscriptionUpdate={updateSubscription}
                            />
                        </div>
                    </ModalDialog>
                </ModalOverflow>
            </Modal>
            {/* New Topic modal */}
            <Modal
                open={groupToAdd}
                onClose={() => setGroupToAdd(false)}>
                <ModalDialog
                    color="neutral"
                    layout="center"
                    size="sm"
                    variant="plain"
                    minWidth={800}>
                    <ModalClose />
                    <DialogTitle>
                        Create new topic
                    </DialogTitle>
                    <DialogContent>
                        Define keywords to spotlight key insights from reviews.
                    </DialogContent>
                    <Divider inset="none" />
                    <div className='p-4'>
                        <GroupPopUpComponent
                            app={app}
                            title=''
                            message=''
                            type='group'
                            handler={replySent}
                        />
                    </div>
                </ModalDialog>
            </Modal>
            {/* Review list Modal */}
            <Modal
                open={showReviews}
                onClose={() => setShowReviews(false)}>
                <ModalDialog
                    color="neutral"
                    layout="center"
                    size="lg"
                    variant="plain">
                    <ModalClose />
                    <Typography
                        component="h2"
                        id="close-modal-title"
                        level="h4"
                        textColor="inherit"
                        sx={{ fontWeight: 'lg' }}
                    >
                        Reviews
                    </Typography>
                    <div>
                        {currentReviews && currentReviews.length === 0 ?
                            <EmptyMessageComponent
                                title="No reviews found"
                                description="No reviews found for this issue."
                            /> :
                            <div className='review-list'>
                                {
                                    currentReviews && currentReviews.map((rev: any) =>
                                        <ReviewComponent
                                            app={app}
                                            review={rev}
                                            tokens={[currentWord]} />
                                    )
                                }
                            </div>
                        }
                    </div>
                </ModalDialog>
            </Modal>
            {/* Page Banner */}
            <Alert
                className="mb-3"
                size="lg"
                variant="soft"
                color="neutral"
                endDecorator={
                    <Button
                        color={viewMode === 'global' ? 'neutral' : 'primary'}
                        size='sm'
                        variant={viewMode === 'global' ? 'outlined' : 'solid'}
                        onClick={toggleView}>
                        {viewMode === 'global' ? 'Manage' : 'Done'}
                    </Button>
                }>
                <div>
                    <div>
                        <Typography
                            level="title-md">
                            Topics & keywords
                        </Typography>
                    </div>
                    <Typography
                        level="body-sm">
                        Here you can group reviews into topics by matching keywords,
                        giving you a clear view of what your users care about most.
                    </Typography>
                </div>
            </Alert>
            {/* Filters and Actions */}
            {viewMode === 'global' &&
                <Box
                    component='section'
                    color='primary'
                    sx={{
                        marginBottom: 2,
                        backgroundColor: '#f4f4f4',
                        borderRadius: '0.5rem',
                        padding: '1rem',
                    }}>
                    <div className='row'>
                        <div className='col-auto mt-auto'>
                            <div className='row'>
                                <div
                                    className='col-auto my-auto '>
                                    <Avatar
                                        alt={app.name + 'App icon'}
                                        src={app.icon}
                                        size='lg'>
                                        {helper.getInitials(app.name)}
                                    </Avatar>
                                </div>
                            </div>
                        </div>
                        <div className='col-auto my-auto'>
                            <FormLabel
                                sx={{
                                    fontSize: '0.75rem',
                                    marginBottom: 0.25
                                }}>
                                Source
                            </FormLabel>
                            <Select
                                color="neutral"
                                defaultValue={'all'}
                                size="sm"
                                variant="outlined"
                                onChange={filterByStore}>
                                <Option value="all">
                                    <span className="me-2"><FontAwesomeIcon icon={faStore} /></span>
                                    All
                                </Option>
                                <Option value="apple">
                                    <span className="me-2"><FontAwesomeIcon icon={faAppStore} />
                                    </span> Appstore
                                </Option>
                                <Option value="google"><span className="me-2">
                                    <FontAwesomeIcon icon={faGooglePlay} /></span> Playstore
                                </Option>
                            </Select>
                        </div>
                        <div className='col-auto my-auto'>
                            <FormLabel
                                sx={{
                                    fontSize: '0.75rem',
                                    marginBottom: 0.25
                                }}>
                                Sentiment
                            </FormLabel>
                            <Select
                                color="neutral"
                                defaultValue={'all'}
                                size="sm"
                                variant="outlined"
                                onChange={filterBySentiment}>
                                <Option value="all">
                                    All
                                </Option>
                                <Option value="good">
                                    Good
                                </Option>
                                <Option value="neutral">
                                    Neutral
                                </Option>
                                <Option value="bad">
                                    Bad
                                </Option>
                            </Select>
                        </div>
                        <div className='col-auto my-auto'>
                            <FormLabel
                                sx={{
                                    fontSize: '0.75rem',
                                    marginBottom: 0.25
                                }}>
                                Status
                            </FormLabel>
                            <Select
                                color="neutral"
                                defaultValue={'all'}
                                size="sm"
                                variant="outlined"
                                onChange={filterByState}
                                renderValue={(selected) =>
                                    selected && (
                                        <Chip
                                            size='sm'
                                            color={getStateColor(selected.value as string)}
                                            variant="soft">
                                            {selected.label}
                                        </Chip>
                                    )
                                }>
                                {STATE_OPTIONS.map((option) => (
                                    <Option key={option.value} value={option.value}>
                                        <Stack direction="row" spacing={1} alignItems="center">
                                            <Chip
                                                size='sm'
                                                color={getStateColor(option.value)}
                                                variant="soft">
                                                {option.label}
                                            </Chip>
                                        </Stack>
                                    </Option>
                                ))}
                            </Select>
                        </div>
                        <div className='col-auto my-auto'>
                            <FormLabel
                                sx={{
                                    fontSize: '0.75rem',
                                    marginBottom: 0.25
                                }}>
                                Version
                            </FormLabel>
                            <Select
                                color="neutral"
                                placeholder="All versions"
                                size="sm"
                                variant="outlined"
                                onChange={filterByVersion}>
                                {
                                    versions.reverse().map((version: string) => {
                                        return (
                                            <Option value={version}>
                                                {version}
                                            </Option>
                                        );
                                    })
                                }
                            </Select>
                        </div>
                        <div className='col-auto my-auto'>
                            <FormLabel
                                sx={{
                                    fontSize: '0.75rem',
                                    marginBottom: 0.25
                                }}>
                                Rating
                            </FormLabel>
                            <Select
                                value={currentRating || 5}
                                color="neutral"
                                size="sm"
                                variant="outlined"
                                placeholder="Filter by rating"
                                onChange={(_, newValue) => setCurrentRating(newValue ?? 5)}
                                renderValue={(selected) =>
                                    selected ? (
                                        <Stack direction="row" spacing={1} alignItems="center">
                                            <Rating
                                                value={Number(selected.value)}
                                                readOnly size="small"
                                                emptyIcon={<Star
                                                    style={{ opacity: 0.55 }}
                                                    fontSize="inherit" />} />
                                            <Typography level='body-xs'>
                                                {selected.value} Stars
                                            </Typography>
                                        </Stack>
                                    ) : (
                                        "Filter by rating"
                                    )
                                }
                            >
                                {[5, 4, 3, 2, 1].map((rating) => (
                                    <Option
                                        key={rating}
                                        value={rating}>
                                        <Stack direction="row"
                                            spacing={1}
                                            alignItems="center">
                                            <Rating
                                                value={rating}
                                                readOnly size="small"
                                                emptyIcon={<Star
                                                    style={{ opacity: 0.55 }}
                                                    fontSize="inherit" />} />
                                            <Typography level='body-xs'>
                                                {rating} Stars
                                            </Typography>
                                        </Stack>
                                    </Option>
                                ))}
                            </Select>
                        </div>
                        <div className='col-auto my-auto'>
                            <FormLabel
                                sx={{
                                    fontSize: '0.75rem',
                                    marginBottom: 0.25
                                }}>
                                Country
                            </FormLabel>
                            <Select
                                color="neutral"
                                placeholder="All countries"
                                size="sm"
                                variant="outlined"
                                onChange={(_, newValue) => filterByTerritoryCode(null, newValue)}>
                                {
                                    territories.map((territory: string) => {
                                        return (
                                            <Option key={territory} value={territory}>
                                                {territory === 'All' ? territory : helper.getCountryName ? helper.getCountryName(territory) : territory}
                                            </Option>
                                        );
                                    })
                                }
                            </Select>
                        </div>
                        <div className='col-auto my-auto'>
                            <FormLabel
                                sx={{
                                    fontSize: '0.75rem',
                                    marginBottom: 0.25
                                }}>
                                Date range
                            </FormLabel>
                            <DateFilter
                                selectedFilter={selectedFilter}
                                onChange={setSelectedFilter} />
                        </div>
                    </div>
                </Box>
            }
            {viewMode === 'global' && app && subscription && (subscription.plan === 'AAA' || subscription.plan === 'U') &&
                <WingmanKeywords
                    count={currentItems && currentItems.length}
                    expanded={expanded}
                    setExpanded={setExpanded}
                    app={app} />
            }
            {app && subscription && (subscription.plan === 'AA') &&
                <Alert
                    className="mb-3"
                    size="lg"
                    variant="soft"
                    color="primary"
                    endDecorator={
                        <Button
                            size="sm"
                            variant="soft"
                            color="primary"
                            onClick={() => setShowPlanSettings(true)}
                        >
                            See plans
                        </Button>
                    }
                >
                    <div>
                        <strong>Activate the Wingman</strong>
                        <Typography level="body-sm">
                            Wingman provides clear, practical guidance and smart summaries of user reviews to help you improve your app based on real feedback.
                        </Typography>
                        <Typography level="body-sm">
                            This feature is available on the <b>Growth</b> and <b>Premium</b> plans.
                        </Typography>
                    </div>
                </Alert>
            }
            {/* Error handling */}

            {loading ?
                <LoadingSpinnerComponent />
                :
                <div className='col'>
                    <div className='mt-4'>
                        {viewMode === 'global' &&
                            <Stack
                                spacing={2}>
                                <Card
                                    variant="outlined"
                                    color='neutral'
                                    sx={{
                                        ...cardStyles.base
                                    }}>
                                    <div>
                                        <Stack direction="row" alignItems="center" spacing={1}>
                                            <LocalOffer sx={{ color: '#6366f1', fontSize: '1.1rem' }} />
                                            <Typography
                                                color='neutral'
                                                fontWeight={600}
                                                level='body-xs'>
                                                {"Words".toUpperCase()}
                                            </Typography>
                                        </Stack>
                                        <Typography
                                            color='neutral'
                                            fontWeight={400}
                                            level='body-xs'
                                            className='ps-4 mt-1'
                                            sx={{ mb: 1 }}>
                                            Explore the most frequently mentioned words in user reviews, helping you identify key themes and areas of interest.
                                        </Typography>
                                    </div>
                                    <Divider />
                                    {currentItems && hbHelper.countKeywords(currentItems).length === 0 ?
                                        <EmptyMessageComponent
                                            title={'No relevant words found.'}
                                            description={'We couldn\'t find any relevant words in the current selection.'} />
                                        :
                                        <Table>
                                            <thead>
                                                <tr>
                                                    <th style={{ backgroundColor: '#ffffff' }}>Word</th>
                                                    <th style={{ backgroundColor: '#ffffff' }} className='text-center'>Hits</th>
                                                    <th style={{ backgroundColor: '#ffffff' }} className='text-center'>Overall</th>
                                                </tr>
                                            </thead>
                                            {currentItems && hbHelper.countKeywords(currentItems).slice(0, currentLimit).map((word: any, index: number) => (
                                                <tr key={index}>
                                                    <td>
                                                        <Typography
                                                            level="body-sm"
                                                            fontWeight={700}>
                                                            <Button
                                                                variant='plain'
                                                                color='neutral'
                                                                style={{
                                                                    textDecoration: 'underline',
                                                                }}
                                                                onClick={() => showReviewsFor(word.text)}>
                                                                {word.text}
                                                            </Button>
                                                        </Typography>
                                                    </td>
                                                    <td className='text-center'>
                                                        <Typography
                                                            level="body-sm">
                                                            {word.value}
                                                        </Typography>
                                                    </td>
                                                    <td className='text-center'>
                                                        <Typography
                                                            level="body-sm">
                                                            {((word.value / currentItems.length) * 100).toFixed(0)} %
                                                        </Typography>
                                                    </td>
                                                </tr>
                                            ))
                                            }
                                        </Table>
                                    }

                                    {currentItems && hbHelper.countKeywords(currentItems).length > currentLimit &&
                                        <>
                                            <Button
                                                variant='soft'
                                                color='neutral'
                                                onClick={() => setCurrentLimit(currentLimit + 5)}>
                                                Show more
                                            </Button>
                                        </>
                                    }
                                </Card>

                                <Card
                                    color="neutral"
                                    orientation="vertical"
                                    size="lg"
                                    variant="outlined"
                                    sx={{
                                        ...cardStyles.base
                                    }}>
                                    <div className='row'>
                                        <div className='col my-auto'>
                                            <Stack direction="row" alignItems="center" spacing={1}>
                                                <GridOn sx={{ color: '#6366f1', fontSize: '1.1rem' }} />
                                                <Typography
                                                    color='neutral'
                                                    fontWeight={600}
                                                    level='body-xs'>
                                                    {"Topics".toUpperCase()}
                                                </Typography>
                                            </Stack>
                                            <Typography
                                                color='neutral'
                                                fontWeight={400}
                                                level='body-xs'
                                                className='ps-4 mt-1'
                                                sx={{ mb: 1 }}>
                                                Group reviews into topics by matching keywords, giving you a clear view of what your users care about most.
                                            </Typography>
                                        </div>
                                        <div className='col-auto text-end'>
                                            <Button
                                                size='sm'
                                                startDecorator={<Add />}
                                                onClick={() => setGroupToAdd(true)}>
                                                Add new topic
                                            </Button>
                                        </div>
                                    </div>

                                    <Divider />
                                    {issues && issues.length === 0 &&
                                        <EmptyMessageComponent
                                            title={'You don\'t have group created yet!.'}
                                            description={'You can create groups and associate keywords to \
                                                        see your reviews separated by topic.'} />
                                    }

                                    {issues && issues.length !== 0 &&
                                        <>
                                            <TopKeywordsComponent
                                                reviews={currentItems}
                                                app={app}
                                                store={currentStore}
                                                version={currentVersion}
                                                state={currentState}
                                                showDetails={true} />
                                        </>
                                    }

                                </Card>
                            </Stack>
                        }

                        {viewMode === 'detail' &&
                            <div className='mt-3'>
                                <ReviewsDistributionByIssue
                                    reviews={currentItems}
                                    issues={issues}
                                    handler={updatePage} />
                            </div>
                        }
                    </div>
                </div>
            }
        </div >
    );
}

export default KeywordsComponent;